// Shared Framer Motion animation presets
// Extracted to avoid inline object creation on every render

export const FADE_IN = { initial: { opacity: 0 }, animate: { opacity: 1 } };
export const FADE_EXIT = { initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 } };
export const SLIDE_UP = { initial: { opacity: 0, y: 15 }, animate: { opacity: 1, y: 0 } };
export const SLIDE_UP_LG = { initial: { opacity: 0, y: 20 }, animate: { opacity: 1, y: 0 } };
export const SCALE_IN = { initial: { opacity: 0, scale: 0.95 }, animate: { opacity: 1, scale: 1 } };
export const SCALE_IN_Y = { initial: { opacity: 0, scale: 0.95, y: 20 }, animate: { opacity: 1, scale: 1, y: 0 } };
export const MODAL_OVERLAY = { initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 } };
export const MODAL_CONTENT = { initial: { opacity: 0, y: 15 }, animate: { opacity: 1, y: 0 }, exit: { opacity: 0, y: 15 } };
